import { render, staticRenderFns } from "./EmployeesByWorkingYears.vue?vue&type=template&id=b2963aee&scoped=true&"
import script from "./EmployeesByWorkingYears.vue?vue&type=script&lang=js&"
export * from "./EmployeesByWorkingYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2963aee",
  null
  
)

export default component.exports